import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as Func from '../../../../../helpers/functions';
import i18n from "../../../../../constants/initLng";
import action from "../../../../../actions";
import DEFINE from '../../../../../constants/Define';
import * as HMS from "../../../common/component/Index";
import * as UserComponent from './CommonComponent';
import { message, Tooltip, Icon, Tag } from 'antd';
import Input from '../../../common/component/Input';
import PasswordInput from '../../../common/component/PasswordInput';
import Select, { Option } from '../../../common/component/Select';
import UploadImage from '../../../common/component/UploadImage';
import $ from 'jquery'

const defaultValue = {
    action: "CREATE",
    data: { status: true },
    allProperties: [],
    isSubmit: false,
    isFetching: false,
    isFetchingUpdate: false,
    isGetItem: false,
    validation: {},
    isUpload: false,
};

let permissionActions = [];

class ActionComponent extends Component {

    passwordInputRef = React.createRef();
    passwordValue = '';

    state = defaultValue;

    componentDidMount() {
        const { match } = this.props;
        permissionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.USER);
        if (Object.keys(match.params).length > 0) {
            this.setState({ action: "UPDATE" });
            this.props.onGetItemUser({ id: match.params.id, props: this.props });
        }
        this.props.onGetRoleUser();
        this.props.onListAllProperties();
    }

    validation = (field, reload) => {
        const { t } = this.props;
        let data = this.state.data;
        let result = {};
        if (!reload) {
            let validate = {
                minLength: { phoneNumber: t('validation.minPhone'), password: t('validation.minpassword') },
                maxLength: { phoneNumber: t('validation.maxPhone') },
                isPhone: { phoneNumber: t('validation.isPhone') },
                isEmail: { email: t('validation.email') },
                strongPassword: { password: t('validation.password') },
                required: {
                    firstname: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.user.firstname`)),
                    lastname: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.user.lastname`)),
                    email: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.user.email`)),
                    password: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.user.password`)),
                    roleId: Func.formatValidation(t('validation.statusCode.code.11'), t(`item.user.roleId`)),
                }
            };
            // if (data.roleId != DEFINE.GENERAL.ROLE_ID.ADMIN) {
            //     validate.required.propertyIds = Func.formatValidation(t('validation.statusCode.code.11'), t(`item.user.propertyIds`));
            // }

            let valueValidate = {
                minLength: { phoneNumber: 8, password: 6 },
                maxLength: { phoneNumber: 12 },
            };
            if (this.state.action === "UPDATE") {
                let required = validate.required;
                let newRequired = Func.removeElementObject(required, 'password');
                validate = { ...validate, required: newRequired }
            }
            const dataForValidation = { ...data };
            if (this.state.action === "CREATE") {
                dataForValidation.password = this.getPasswordValue();
            }
            result = Func.multipleValidate(dataForValidation, validate, valueValidate);
        } else {
            let validation = this.state.validation;
            result = Func.reloadValidation(validation, field)
        }
        this.setState({ validation: result });
        return result;
    };

    componentWillReceiveProps(nextProps) {
        this.setState({
            isSubmit: nextProps.users.isSubmit,
            isGetItem: nextProps.users.isGetItem,
            isUpload: nextProps.file.isFetching,
            isFetchingUpdate: nextProps.users.isFetchingUpdate
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.users.roleUser !== prevProps.users.roleUser) {
            if (this.props.users.roleUser.length > 0) {
                this.setState({
                    roleUser: this.props.users.roleUser,
                });
            }
        }
        if (this.props.properties !== prevProps.properties) {
            let newData = Func.customOptionSelectHMS(this.props.properties.allProperties, ['name', 'id']);
            this.setState({
                allProperties: newData,
            });
        }
        if (this.props.file !== prevProps.file) {
            if (this.props.file.file) {
                this.setState({
                    file: this.props.file.file,
                    data: { ...this.state.data, avatar: this.props.file.file.data.fileName }
                });
            }
        }
        if (this.props.users.dataUpdate !== prevProps.users.dataUpdate) {
            if (this.props.users.dataUpdate.properties && this.props.users.dataUpdate.properties.length > 0) {
                this.props.users.dataUpdate.propertyIds = [];
                this.props.users.dataUpdate.properties.map((i) => {
                    this.props.users.dataUpdate.propertyIds.push(i.id);
                });
            }
            this.setState({
                data: Func.removeElementObject(this.props.users.dataUpdate, 'password'),
            })
        }
    }

    onChange = (e) => {
        let params = Func.getValueForm(e);
        this.setState({
            data: {
                ...this.state.data,
                [params.name]: typeof params.value === 'string' ? params.value.trimLeft() : params.value,
            }
        });
        this.validation(params.name, true)
    };

    onSubmit = (e) => {
        e.preventDefault();
        let result = this.validation();
        if (Object.keys(result).length < 1) {
            if (this.state.action === "CREATE") {
                let dataCreate = this.state.data;
                const password = this.getPasswordValue();
                this.props.onCreateUser({ data: dataCreate, password, props: this.props });
                this.clearPassword();
            } else if (this.state.action === "UPDATE") {
                let dataUpdate = this.state.data;
                this.props.onUpdateUser({ data: { ...dataUpdate, id: this.state.data.id }, props: this.props });
            }
        } else {
            message.error(i18n.t('validation.checkForm'))
        }
    };

    onForceMfaChange = (forceMfa) => {
        const { id } = this.state.data;
        if (id) {
            this.props.onUpdateForceMfa({ id, forceMfa });
        }
    };

    uploadFile = (file) => {
        let data = this.state.data;
        data = Func.removeElementObject(data, 'avatar');
        this.setState({
            isUpload: true,
            data: data
        });
        this.props.onUploadFile({ file: file.target.files[0], directory: "avatar", isFile: 1 });
    };

    getPasswordValue = () => {
        if (this.passwordInputRef.current && this.passwordInputRef.current.input) {
            return this.passwordInputRef.current.input.value || '';
        }
        return this.passwordValue || '';
    };

    clearPassword = () => {
        this.passwordValue = '';
        if (this.passwordInputRef.current && this.passwordInputRef.current.input) {
            this.passwordInputRef.current.input.value = '';
        }
    };

    onPasswordChange = (e) => {
        const value = e && e.target ? e.target.value : '';
        this.passwordValue = value;
        this.validation('password', true);
    };

    render() {
        const { t } = this.props;
        const { data, validation, isSubmit, isGetItem, action, roleUser, allProperties, imageUrl, isUpload, file } = this.state;
        const isForceMfaUpdating = (this.props.users.forceMfaUpdatingIds || []).includes(data.id);
        return (
            <Fragment>
                <HMS.LoadingComponent spinning={isSubmit}>
                    <HMS.PageListComponent>
                        <HMS.HeaderListComponent
                            path={this.props.match.path}
                            groupPath={'users'}
                            titleHeader={
                                action === "CREATE" ?
                                    Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.user.title')}`).toLowerCase())
                                    : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.user.title')}`.toLowerCase()))
                            }
                        />
                        <HMS.FormActionComponent
                            onSubmit={this.onSubmit}
                            isSubmit={isSubmit}
                            action={action}
                            isGetItem={isGetItem}
                            findParentRoute={() => Func.findParentRoute('users', this.props)}
                            activeComponent={true}
                            onChangeActive={this.onChange}
                            titleActiveComponent={t(`item.user.deactiveUser`)}
                            submitButtonRight={true}
                            statusActive={data.deactivated}
                        >
                            <HMS.FormWrapperItem>
                                <div className={`col-md-4 pl-5`}>
                                    <div className={`row`}>
                                        <div className={`col-md-12`}>
                                            <HMS.FormWrapperInputComponent
                                                isRequired={true}
                                                isValidation={true}
                                                dataValidation={data.email}
                                                validation={validation.email}
                                                labelTitle={t(`item.user.email`)}
                                            >
                                                <Input placeholder="" type={`text`}
                                                    className={`form-control`}
                                                    name={`email`} onChange={this.onChange}
                                                    disabled={action === "UPDATE"}
                                                    value={Func.checkUndefine(data.email)} />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                    </div>
                                    <div className={`row`}>
                                        {action === "CREATE" && (
                                            <div className={`col-md-12`}>
                                                <HMS.FormWrapperInputComponent
                                                    isRequired={true}
                                                    isValidation={true}
                                                    dataValidation={this.getPasswordValue()}
                                                    validation={validation.password}
                                                    labelTitle={
                                                        <Fragment>
                                                            {t(`item.user.password`)}
                                                            <Tooltip title={t('validation.password')} className="ml-2">
                                                                <Icon type="info-circle"
                                                                    style={{ color: 'rgba(0,0,0,.45)' }} />
                                                            </Tooltip>
                                                        </Fragment>
                                                    }
                                                >
                                                    <PasswordInput placeholder="" type={`password`}
                                                        data-lpignore="true"
                                                        autoComplete="off"
                                                        name={`password`} onChange={this.onPasswordChange}
                                                        ref={this.passwordInputRef} />
                                                </HMS.FormWrapperInputComponent>
                                            </div>
                                        )}
                                    </div>
                                    <div className={`row`}>
                                        <div className={`col-md-12`}>
                                            <HMS.FormWrapperInputComponent
                                                isRequired={true}
                                                isValidation={true}
                                                dataValidation={data.roleId}
                                                validation={validation.roleId}
                                                labelTitle={t(`item.user.roleId`)}
                                            >
                                                <HMS.LoadingComponent
                                                    spinning={roleUser && Object.keys(roleUser).length < 0}>
                                                    <Select className={`form-control`} name={`roleId`}
                                                        value={Func.checkUndefine(data.roleId)}
                                                        onChange={this.onChange}>
                                                        <Option
                                                            value={``}>{Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.user.roleId")).toLowerCase())}</Option>
                                                        {
                                                            roleUser && roleUser.map((i, k) => {
                                                                return (
                                                                    <Option value={i.id} key={k}> {i.name}</Option>
                                                                )
                                                            })
                                                        }
                                                    </Select>
                                                </HMS.LoadingComponent>
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                    </div>
                                </div>
                                <div className={`col-md-4 pl-4`}>
                                    <div className={`row`}>
                                        <div className={`col-md-6`}>
                                            <HMS.FormWrapperInputComponent
                                                isRequired={true}
                                                isValidation={true}
                                                dataValidation={data.lastname}
                                                validation={validation.lastname}
                                                labelTitle={t(`item.user.lastname`)}
                                            >
                                                <Input placeholder="" type={`text`}
                                                    className={`form-control`}
                                                    name={`lastname`} onChange={this.onChange}
                                                    value={Func.checkUndefine(data.lastname)} />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                        <div className={`col-md-6`}>
                                            <HMS.FormWrapperInputComponent
                                                isRequired={true}
                                                isValidation={true}
                                                dataValidation={data.firstname}
                                                validation={validation.firstname}
                                                labelTitle={t(`item.user.firstname`)}
                                            >
                                                <Input placeholder="" type={`text`}
                                                       className={`form-control`}
                                                       name={`firstname`} onChange={this.onChange}
                                                       value={Func.checkUndefine(data.firstname)} />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                    </div>
                                    <div className={`row`}>
                                        <div className={`col-md-12`}>
                                            <HMS.FormWrapperInputComponent
                                                isValidation={true}
                                                dataValidation={data.phoneNumber}
                                                validation={validation.phoneNumber}
                                                labelTitle={t(`item.user.phoneNumber`)}
                                            >
                                                <Input placeholder="" type={`text`}
                                                    className={`form-control`}
                                                    name={`phoneNumber`} onChange={this.onChange}
                                                    value={Func.checkUndefine(data.phoneNumber)} />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                    </div>
                                    <div className={`row`}>
                                        <div className={`col-md-12`}>
                                            {
                                                (data.roleId > DEFINE.GENERAL.ROLE_ID.ADMIN || !data.roleId) && (
                                                    <HMS.FormWrapperInputComponent
                                                        labelTitle={t(`item.user.propertyIds`)}
                                                    >
                                                        <HMS.LoadingComponent spinning={allProperties.length < 0}>
                                                            <HMS.SelectComponent name={`propertyIds`}
                                                                optionFilterProp="children"
                                                                mode="multiple"
                                                                className={`hms-form-control`}
                                                                value={data.propertyIds}
                                                                showSearch
                                                                hmsData={allProperties}
                                                                onChange={(e) => this.onChange(e)} />
                                                        </HMS.LoadingComponent>
                                                    </HMS.FormWrapperInputComponent>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className={`col-md-4 pl-4 pr-5`}>
                                    <div className={`row`}>
                                        <div className={`col-md-12`}>
                                            <HMS.FormWrapperInputComponent
                                                labelTitle={t(`item.user.avatar`)}
                                            >
                                                {/* <HMS.LoadingComponent spinning={isUpload}>
                                                    {
                                                        (file || data.avatarUrl) &&
                                                        <img
                                                            src={`${DEFINE.GENERAL.CDN_IMG_DEFAULT}${file ? file.data.fileUrl : data.avatarUrl}`}
                                                            width={`100%`} onClick={() => $('.uploadFile').click()}
                                                            className={`cursorPointer mb-2`} />
                                                    }
                                                    <label
                                                        className={`file-upload ${file ? "hide" : "btn btn-primary"}`}>
                                                        Browse for file ... <input type="file" name={`file`}
                                                            accept={`.jpg,.png`}
                                                            onChange={this.uploadFile}
                                                            className={`uploadFile`} />
                                                    </label>
                                                </HMS.LoadingComponent> */}
                                                <UploadImage
                                                    multiple={false}
                                                    loading={isUpload}
                                                    thumbnailSize="100%"
                                                    buttonSize={120}
                                                    disabledRemove={true}
                                                    thumbnailStyle={{ maxHeight: 300 }}
                                                    uploadText={t('item.tour.uploadFile')}
                                                    loadingText={t('item.tour.uploading')}
                                                    onChange={this.uploadFile}
                                                    thumbnails={file || data.avatarUrl ? [`${DEFINE.GENERAL.CDN_IMG_DEFAULT}${file ? file.data.fileUrl : data.avatarUrl}`] : undefined} />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                    </div>
                                </div>
                            </HMS.FormWrapperItem>
                            {action === "UPDATE" && (
                                <HMS.FormWrapperItem classParent="px-5 pb-4">
                                    <div className="col-md-12 pt-4">
                                        <h4 className="mb-3">
                                            {t('item.user.accountSecurity')}
                                            <Tag color="gold" className="ml-2">{t('item.user.newLabel')}</Tag>
                                        </h4>
                                        <div className="p-3 mb-4" style={{ border: '1px solid #e8e8e8', borderRadius: 8 }}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16 }}>
                                                <div>
                                                    <div className="font-bold">{t('item.user.mfaEnabled')}</div>
                                                    <div className="text-muted">{t('item.user.mfaStatusDescription')}</div>
                                                </div>
                                                <UserComponent.MfaStatus enabled={data.mfaEnabled} />
                                            </div>
                                        </div>
                                        <div className="p-3" style={{ border: '1px solid #e8e8e8', borderRadius: 8 }}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16 }}>
                                                <div>
                                                    <div className="font-bold">{t('item.user.forceMfa')}</div>
                                                    <div className="text-muted">{t('item.user.forceMfaDescription')}</div>
                                                </div>
                                                <UserComponent.ForceMfaControl
                                                    checked={data.forceMfa}
                                                    loading={isForceMfaUpdating}
                                                    disabled={!permissionActions || !permissionActions.allowUpdate}
                                                    onChange={this.onForceMfaChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </HMS.FormWrapperItem>
                            )}
                        </HMS.FormActionComponent>
                    </HMS.PageListComponent>
                </HMS.LoadingComponent>
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        users: state.userReducer,
        properties: state.propertyReducer,
        file: state.uploadReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onGetRoleUser: () => {
            dispatch(action.getRoleUserAction())
        },
        onListAllProperties: (filters) => {
            dispatch(action.dataAllPropertyAction(filters))
        },
        onUploadFile: (filters) => {
            dispatch(action.uploadAction(filters))
        },
        onCreateUser: (params) => {
            dispatch(action.createUserAction(params))
        },
        onUpdateUser: (params) => {
            dispatch(action.updateUserAction(params))
        },
        onGetItemUser: (params) => {
            dispatch(action.getUpdateUserAction(params))
        },
        onUpdateForceMfa: (params) => {
            dispatch(action.updateForceMfaAction(params))
        },
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ActionComponent)));
